// Canonical content for Mujeres Motor homepage & navigation.
// All copy in Spanish. Image URLs are externally hosted editorial AI renders.

export const STORIES = [
  {
    slug: "ana-rivera-cdmx",
    name: "Ana Rivera",
    city: "Ciudad de México",
    industry: "Manufactura",
    quote: "La industria también es nuestra.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/a07233097b2b0c61a7b27309fe92d723e9f2810c077e48e2e4e249b88e536bcc.jpeg",
    duration: "24 min",
  },
  {
    slug: "lucia-martinez-oaxaca",
    name: "Lucía Martínez",
    city: "Oaxaca",
    industry: "Artesanía",
    quote: "Cada hilo cuenta la memoria de mi pueblo.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/8e0fba0fb20c179f8fc5e7353f36167b1be74f5c55397c2f90d09dc8c62452e1.jpeg",
    duration: "18 min",
  },
  {
    slug: "sofia-hernandez-monterrey",
    name: "Sofía Hernández",
    city: "Monterrey",
    industry: "Tecnología",
    quote: "El código también se escribe en español.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/1b3d8c822eed368afbd2da15ed27a09ea38bff6db4ee2b2ea92bdbada48b94b2.jpeg",
    duration: "22 min",
  },
  {
    slug: "carmen-uc-yucatan",
    name: "Carmen Uc",
    city: "Yucatán",
    industry: "Cooperativa",
    quote: "Cosechamos comunidad, no solo agave.",
    image:
      "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/9c6b436b05fc780a7292a9b000b09a456250516fe5f3e214115f35bc6ca350b6.jpeg",
    duration: "26 min",
  },
];

export const EDITORIAL_IMAGES = {
  production:
    "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/b2cee2d298c4908cca7ac2ca619759cb76c1f1c96aad5406258a08d210f796c0.jpeg",
  community:
    "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/a09c29dceb12aa9c14f72d24f04949f9e2b8e13b5b7608ca8159cd784bc83779.jpeg",
  sponsor:
    "https://static.prod-images.emergentagent.com/jobs/fcfb0e3d-78af-4eb0-9bc1-020bea71b151/images/3c6ada883f1cb8ea9c97ee3a07ff5230540a772fd91da058391ae435b922c592.jpeg",
};

export const ECOSYSTEM = [
  {
    icon: "Film",
    title: "Documentales",
    desc: "Miniserie episódica en formato largo, grabada en su ciudad.",
  },
  {
    icon: "Mic",
    title: "Podcast",
    desc: "Conversaciones íntimas de 40-60 minutos con cada protagonista.",
  },
  {
    icon: "Smartphone",
    title: "Social",
    desc: "Contenido vertical semanal: reels, carousels y clips documentales.",
  },
  {
    icon: "Calendar",
    title: "Eventos",
    desc: "Screenings privados, paneles editoriales y encuentros de networking.",
  },
  {
    icon: "Users",
    title: "Comunidad",
    desc: "Red de mujeres líderes con mentorías, directorio y espacios seguros.",
  },
];

export const NAV_LINKS = [
  { label: "Historias", href: "/stories" },
  { label: "Podcast", href: "/podcast" },
  { label: "Comunidad", href: "/community" },
  { label: "Eventos", href: "/events" },
  { label: "Para Marcas", href: "/for-brands" },
  { label: "Nosotras", href: "/about" },
];

export const FOOTER_NAV = {
  Navegación: NAV_LINKS,
  Contenido: [
    { label: "Historias", href: "/stories" },
    { label: "Podcast", href: "/podcast" },
    { label: "Eventos", href: "/events" },
    { label: "Recursos", href: "/resources" },
  ],
  Conecta: [
    { label: "Instagram", href: "https://www.instagram.com/mujeres_motor", icon: "Instagram" },
    { label: "YouTube", href: "#", icon: "Youtube" },
    { label: "TikTok", href: "#", icon: "Music2" },
    { label: "LinkedIn", href: "#", icon: "Linkedin" },
    { label: "Spotify", href: "#", icon: "Music" },
  ],
};

export const STATS = [
  { value: "+50", label: "Historias documentadas" },
  { value: "+20", label: "Ciudades" },
  { value: "+12", label: "Industrias" },
  { value: "1", label: "Comunidad viva" },
];
